<template>
  <div class="k2-bans">
    <div v-if="!live" class="k2-ban k2-ban--info" role="status">
      <k2-icon n="mdi-calendar-blank-outline" :s="20" />
      <div>
        <b>{{ tx("ban.date_t", { date: dateText }) }}</b>
        <span>{{ tx("ban.date_s") }}</span>
      </div>
      <button type="button" data-fk="live" @click="$emit('live')">{{ tx("ban.live") }}</button>
    </div>
    <div v-if="offline" class="k2-ban" :class="bad ? 'k2-ban--bad' : 'k2-ban--warn'" role="alert">
      <k2-icon n="mdi-wifi-off" :s="22" />
      <div>
        <b>{{ tx("ban.offline_t") }}</b>
        <span>{{ lastOkText ? tx("ban.offline_s", { time: lastOkText }) : tx("ban.offline_never") }}</span>
      </div>
      <button type="button" data-fk="retry" @click="$emit('retry')">{{ tx("ban.retry") }}</button>
    </div>
    <div v-if="soundBlocked" class="k2-ban k2-ban--info" role="status">
      <k2-icon n="mdi-volume-off" :s="20" />
      <div>
        <b>{{ tx("ban.sound_t") }}</b>
        <span>{{ tx("ban.sound_s") }}</span>
      </div>
      <button type="button" data-fk="unlock" @click="$emit('unlock')">{{ tx("ban.sound_btn") }}</button>
    </div>
  </div>
</template>

<script>
import K2Icon from "./K2Icon.vue";
import kds2Text from "@/mixins/kds2Text";

// Trake ispod gornje trake: stariji dan, nema veze, zvuk blokiran.
export default {
  name: "Kds2Banners",
  components: { K2Icon },
  mixins: [kds2Text],
  props: {
    live: { type: Boolean, default: true },
    dateText: { type: String, default: "" },
    offline: { type: Boolean, default: false },
    bad: { type: Boolean, default: false },
    lastOkText: { type: String, default: "" },
    soundBlocked: { type: Boolean, default: false },
  },
};
</script>
